import * as fromDatatype from '../datatype-library/index';

export interface bl_msg_message_user_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  message_guid: fromDatatype.GuidDataFieldInterface;
  user_type: fromDatatype.VarcharDatatypeInterface;
  user_guid: fromDatatype.GuidDataFieldInterface;
  messenger_channel: fromDatatype.VarcharDatatypeInterface;
  messenger_app: fromDatatype.VarcharDatatypeInterface;
  messenger_id: fromDatatype.VarcharDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}

export class bl_msg_message_user_RowClass implements bl_msg_message_user_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  message_guid: fromDatatype.GuidDataFieldInterface;
  user_type: fromDatatype.VarcharDatatypeInterface;
  user_guid: fromDatatype.GuidDataFieldInterface;
  messenger_channel: fromDatatype.VarcharDatatypeInterface;
  messenger_app: fromDatatype.VarcharDatatypeInterface;
  messenger_id: fromDatatype.VarcharDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}

